<template>
  <v-dialog v-model="active" max-width="400" persistent>
    <v-card>
      <v-card-title class="subtitle-1">
        Return Product
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model.number="form.goodOrderQuantity"
          label="Good Order Qty"
          type="number"
          min="0"
          outlined
          dense
          hide-details="auto"
          class="mt-2"
        />
        <v-text-field
          v-model.number="form.badOrderQuantity"
          label="Bad Order Qty"
          type="number"
          min="0"
          outlined
          dense
          hide-details="auto"
          class="mt-3"
        />
        <div class="mt-2 text-caption grey--text">
          Total: {{ totalQty }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="cancel">
          Cancel
        </v-btn>
        <v-btn color="primary" :disabled="totalQty <= 0" @click="submit">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReturnProductPartialCreateDialog',
  data: () => ({
    active: false,
    /** @type {((param: {goodOrderQuantity: number, badOrderQuantity: number} | null) => void) | null} */
    resolve: null,
    form: {
      goodOrderQuantity: 1,
      badOrderQuantity: 0,
    },
  }),
  computed: {
    totalQty() {
      return (this.form.goodOrderQuantity || 0) + (this.form.badOrderQuantity || 0)
    },
  },
  methods: {
    /** @returns {Promise<{goodOrderQuantity: number, badOrderQuantity: number} | null>} */
    open() {
      this.form = { goodOrderQuantity: 1, badOrderQuantity: 0 }
      this.active = true
      return new Promise((resolve) => { this.resolve = resolve })
    },
    submit() {
      this.active = false
      this.resolve({ ...this.form })
    },
    cancel() {
      this.active = false
      this.resolve(null)
    },
  },
}
</script>
